export const setUnitPreferenceForTrait = (traitId: number, unitId: number) => {
  const stored = localStorage.getItem('unitPreferencesForTraits') || '{}';
  const unitPreferencesForTraits: Record<number, number> = JSON.parse(stored);

  unitPreferencesForTraits[traitId] = unitId;

  localStorage.setItem('unitPreferencesForTraits', JSON.stringify(unitPreferencesForTraits));
};

export const getUnitPreferencesForTraits = (): Record<number, number> => {
  const stored = localStorage.getItem('unitPreferencesForTraits') || '{}';
  try {
    return JSON.parse(stored);
  } catch {
    return {};
  }
};

export const removeUnitPreferenceForTrait = (traitId: string) => {};
